import api from '../utils/api';

export const listConnections = async ({ skip = 0, limit = 100, search = '' } = {}) => {
  const params = new URLSearchParams();
  if (skip) params.append('skip', skip);
  if (limit) params.append('limit', limit);
  if (search) params.append('search', search);
  const url = `/connections/${params.toString() ? `?${params}` : ''}`;
  const response = await api.get(url);
  return response.data;
};

export const getConnection = async (id) => {
  const response = await api.get(`/connections/${id}`);
  return response.data;
};

export const createConnection = async (data) => {
  const response = await api.post('/connections/', data);
  return response.data;
};

export const updateConnection = async (id, data) => {
  const response = await api.put(`/connections/${id}`, data);
  return response.data;
};

export const deleteConnection = async (id) => {
  const response = await api.delete(`/connections/${id}`);
  return response.data;
};

export const testConnection = async (id) => {
  const response = await api.post(`/connections/${id}/test`);
  return response.data;
};

// Database browsing
export const listSchemas = async (connectionId) => {
  const response = await api.get(`/database/${connectionId}/schemas`);
  return response.data;
};

export const listTables = async (connectionId, { schema = null } = {}) => {
  const params = schema ? `?schema=${encodeURIComponent(schema)}` : '';
  const response = await api.get(`/database/${connectionId}/tables${params}`);
  return response.data;
};

export const listColumns = async (connectionId, table, { schema = null } = {}) => {
  const params = new URLSearchParams({ table });
  if (schema) params.append('schema', schema);
  const response = await api.get(`/database/${connectionId}/columns?${params}`);
  return response.data;
};

export const executeQuery = async (connectionId, sql, { params = null, maxRows = 500 } = {}) => {
  const response = await api.post(`/database/${connectionId}/query`, {
    sql,
    params,
    max_rows: maxRows,
  });
  return response.data;
};

export const sampleCollection = async (connectionId, collection, { database = null } = {}) => {
  const params = database ? `?database=${encodeURIComponent(database)}` : '';
  const response = await api.get(
    `/database/${connectionId}/collections/${encodeURIComponent(collection)}/sample${params}`,
  );
  return response.data;
};
